module.exports = __webpack_public_path__ + "static/media/filter4.eced09ff.png";